import React, { useState, useEffect, useContext } from "react";
import { makeStyles, withStyles } from "@mui/styles";
import {
  Link,
  BrowserRouter as Router,
  useParams,
  Redirect,
} from "react-router-dom";
import axios from "axios";
import {
  MarketsProvider,
  MarketsContext,
} from "context/MarketsContext";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import UserService from "services/UserService";
import { getMarket } from "services/ConfigServices";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import TabHeader from "components/Ui/Header/TabHeader";
import VerticalTabs from "./Market/VerticalTabs";
import MembershipsVT from "./Memberships/MembershipsVT";
import TabContext from "@mui/lab/TabContext";
import AppBar from "@mui/material/AppBar";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import ContractualFilesVT from "./ContractualFiles/ContractualFilesVT";
// import ServiceOrdersVT from "./ServiceOrders/ServiceOrdersVT";
// import ClaimsVT from "./Claims/ClaimsVT";
import {
  Navigate, useLocation
} from "react-router-dom";

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);


export default function SelectedMarket(props) {
  const { state } = useLocation();
  if (!state) {
    return (
      <Navigate
        push
        to={{
          pathname: "/admin/markets",
        }}
      />
    )
  }
  else {
    const { marketId, marketName, marketAdminVisibility, initialtabindex, initialsubtabindex } = state;

    return (
      <MarketsProvider>
        <SelectedMarketsChild
          marketId={marketId}
          marketName={marketName}
          marketAdminVisibility={marketAdminVisibility}
          initialtabindex={initialtabindex}
          initialsubtabindex={initialsubtabindex}
        />
      </MarketsProvider>
    );
  }
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "0 0 5px 5px",
    boxShadow: "0 1px 4px 0 rgb(0 0 0 / 14%)",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  /* tabs: {
     borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
   },
   tab: {
     paddingLeft: "0rem",
     marginLeft: "0rem",
     flexDirection: "column",
     textAlign: "left",
     display: "grid",
     justifyContent: "left",
     alignItems: "flex-start",
     maxWidth: "3rem",
     textTransform: "none",
     fontSize: "14px",
     fontFamily: '"Source Sans Pro",sans-serif',
   },
   tabPanel: {
     padding: "0",
   }*/
}));



function SelectedMarketsChild({ marketId, marketName, marketAdminVisibility, initialtabindex, initialsubtabindex }) {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const [value, setValue] = useState(initialtabindex || "0");
  const marketsadmin = permis.includes("markets_create");
  const classes = useStyles();
  const appContext = useContext(MarketsContext);
  const { market, setMarket } = appContext;

  const { parameters } = market;


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  const [isLoading, setIsLoading] = useState(true);

  const url = getMarket(marketId);

  useEffect(() => {
    axios
      .get(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((response) => {
        if (response.data) {
          response.data.marketAdminVisibility = marketAdminVisibility;
        }
        setMarket(response.data || []);
        setIsLoading(false);
      });
  }, [marketId]);

  if (marketId === "") {
    return (
      <Navigate
        push
        to={{
          pathname: "/admin/markets",
        }}
      />
    );
  }

  return (
    <GridContainer>
      <GridItem xs={12}>
        <TabHeader>
          <>
            <Link to="/admin/markets">
              <div
                style={{
                  fontSize: "13px",
                  color: "#fff",
                  opacity: "0.8",
                }}
              >
                {/* <KeyboardBackspaceIcon /> */}
                Marchés
              </div>
            </Link>
            <div
              style={{
                marginLeft: "5px",
                marginTop: "0px",
                marginBottom: "5px",
                fontSize: "15px",
                fontWeight: "bold",
              }}
            >
              / {marketName}
            </div>
          </>
        </TabHeader>
      </GridItem>

      <GridItem xs={12}>
        {!isLoading && (
          <div className={classes.demo2}>
            <TabContext value={value} className={classes.root}>
              <div className={classes.demo2}>
                <AppBar
                  position="static"
                  className={classes.demo3}
                  style={{ boxShadow: "none", shadowColor: "red" }}
                >
                  <StyledTabs
                    value={value}
                    onChange={handleChange}
                    aria-label="styled tabs example"
                    initialselectedindex={0}
                    scrollButtons="auto"
                  >
                    <StyledTab label="A propos" value={"0"} />
                    <StyledTab label="Gestion des adhésions" value={"1"} />
                    <StyledTab label="Pièces contractuelles de marché" value={"2"} />
                    {/* <StyledTab label="Ordres de services" value={"3"} />
                    <StyledTab label="Réclamations" value={"4"} /> */}
                  </StyledTabs>
                  <Typography className={classes.padding} />
                </AppBar>
                <Divider variant="fullWidth" />
                <TabPanel value="0">{<VerticalTabs />}</TabPanel>
                <TabPanel value="1">{<MembershipsVT initialsubtabindex={initialsubtabindex}/>}</TabPanel>
                <TabPanel value="2">{<ContractualFilesVT />}</TabPanel>
                {/* <TabPanel value="3">{<ServiceOrdersVT />}</TabPanel>
                <TabPanel value="4">{<ClaimsVT />}</TabPanel> */}
              </div>
            </TabContext>
          </div>
        )
        }
      </GridItem>
    </GridContainer>
  );
}
